import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import appConfig from 'appConfig';
import {
  CopyInput,
} from '@pearsontechnology/aero-components';
import Modal, { ModalContent } from 'components/Modal';
import messages from './messages';
import {
  SectionLabel,
  LinkSection,
} from './styles';

const buildSSOUrl = ({ cohortId, deploymentId, ssoId }) => {
  const learnspaceURL = appConfig.getLearnspaceURL();
  const continueTo = `${learnspaceURL}/${cohortId}/${deploymentId}`;
  return `${learnspaceURL}/sso/oidc/to?relying_party_id=${ssoId}&continue_to=${encodeURIComponent(continueTo)}`;
};

function EnrollmentLinksModal({ visible, onDismiss, cohortId, deploymentId, ssoId, ltiConsumerKey, ltiConsumerSecret }) {
  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      title={intl.formatMessage(messages.title)}
    >
      <ModalContent>
        { ssoId && (
          <LinkSection>
            <SectionLabel>
              <FormattedMessage {...messages.studentSignupLabel} />
            </SectionLabel>
            <CopyInput
              value={buildSSOUrl({ cohortId, deploymentId, ssoId })}
              labelHidden
              label={intl.formatMessage(messages.studentSignupURL)}
              buttonLabel={intl.formatMessage(messages.copyPrompt)}
              notificationLabel={intl.formatMessage(messages.copyConfirm)}
            />
          </LinkSection>
        )}

        { ltiConsumerKey && ltiConsumerSecret && (
          <LinkSection>
            <SectionLabel>
              <FormattedMessage {...messages.ltiEnrollmentLabel} />
            </SectionLabel>
            <CopyInput
              value={`${appConfig.getLearnspaceURL()}/learn/${cohortId}/${deploymentId}`}
              label={intl.formatMessage(messages.ltiEnrollmentURL)}
              buttonLabel={intl.formatMessage(messages.copyPrompt)}
              notificationLabel={intl.formatMessage(messages.copyConfirm)}
            />

            <CopyInput
              value={ltiConsumerKey}
              label={intl.formatMessage(messages.ltiKey)}
              buttonLabel={intl.formatMessage(messages.copyPrompt)}
              notificationLabel={intl.formatMessage(messages.copyConfirm)}
            />

            <CopyInput
              value={ltiConsumerSecret}
              label={intl.formatMessage(messages.ltiSecret)}
              buttonLabel={intl.formatMessage(messages.copyPrompt)}
              notificationLabel={intl.formatMessage(messages.copyConfirm)}
            />
          </LinkSection>
        )}
      </ModalContent>
    </Modal>
  );
}

EnrollmentLinksModal.propTypes = {
  visible: PropTypes.bool,
  onDismiss: PropTypes.func.isRequired,
  cohortId: PropTypes.string.isRequired,
  deploymentId: PropTypes.string.isRequired,
  ssoId: PropTypes.string,
  ltiConsumerKey: PropTypes.string,
  ltiConsumerSecret: PropTypes.string,
};

export default EnrollmentLinksModal;
